import { Provider as LightProvider } from "@Light/scaffold/Provider";
import * as Sentry from "@sentry/react";
import { Navigate, Route, Routes } from "react-router-dom";
import { scaffold } from "../scaffold";
import { WithInfo, useInfo } from "./WithInfo";
import { WithAccess } from "./WithAccess";
import { Portal } from "./Portal";
import { EmailUnsubscribe } from "./emailUnsubscribe/EmailUnsubscribe";
import { NoContextError } from "@Light/components/auth/NoContextError";
import { Overlay } from "@Light/components/page/Overlay";

export const AppRoutes: React.FC = () => {
  return (
    <LightProvider scaffold={scaffold}>
      <Sentry.ErrorBoundary fallback={<div> Unexpected error</div>}>
        <Routes>
          <Route
            path="/p/:slug/email-unsubscribe"
            element={<EmailUnsubscribe />}
          />
          <Route
            path="/*"
            element={
              <WithInfo>
                <WithAccess>
                  <InfoAccessRoutes />
                </WithAccess>
              </WithInfo>
            }
          />
        </Routes>
      </Sentry.ErrorBoundary>
    </LightProvider>
  );
};

export const InfoAccessRoutes: React.FC = () => {
  const info = useInfo();
  if (!info) {
    return (
      <Overlay>
        <NoContextError />
      </Overlay>
    );
  }

  return (
    <Routes>
      <Route path="/p/*" element={<Portal />} />
      <Route path="/*" element={<Navigate to="/p/no-info" />} />
    </Routes>
  );
};
